import React, { useState } from 'react';
import { Col, Input} from "reactstrap";
import { useTranslation } from 'react-i18next';
import IconButtonWithTooltip from 'components/buttons/IconButtonWithTooltip';
import { ICON_MAPPING } from 'components/iconInput/IconButton';

const ImageUrlInput = ({ label, value, onChange, readOnly }) => {
    const { t } = useTranslation();
    const [isEditMode, setIsEditMode] = useState(false);
    if(isEditMode && !readOnly)
        return (
            <Col className="d-flex align-items-center pl-2">
                <IconButtonWithTooltip  
                    onClick={()=>setIsEditMode(false)}
                    translationId={label} 
                    icon={ICON_MAPPING['thumbnailimage']} 
                    type='IconButton'
                />
                <Input
                    value={value ?? ''}
                    onChange={onChange}
                    className="form-control"
                    placeholder={t(`${label}`)} 
                    type="text"
                />
        </Col>
        )
        
    return (
        <img
            onClick={()=>setIsEditMode(true)}
            src={value || "https://dummyimage.com/300x200/cccccc/ffffff.png&text=No+Image"}
            alt={label}
            width="50%"
            height="200"
            style={{ objectFit: "cover", borderRadius: "8px" }}
        />)
}

export default ImageUrlInput;